var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6948 7.85518C13.6948 10.6424 11.4353 12.9018 8.64815 12.9018C5.86097 12.9018 3.60151 10.6424 3.60151 7.85518C3.60151 5.068 5.86097 2.80854 8.64815 2.80854C11.4353 2.80854 13.6948 5.068 13.6948 7.85518ZM14.7572 7.85518C14.7572 11.2291 12.0221 13.9643 8.64815 13.9643C5.2742 13.9643 2.53906 11.2291 2.53906 7.85518C2.53906 4.48123 5.2742 1.74609 8.64815 1.74609C12.0221 1.74609 14.7572 4.48123 14.7572 7.85518ZM11.5291 6.32303C11.7179 6.14876 11.7179 5.84378 11.5291 5.66951C11.3548 5.48071 11.0499 5.48071 10.8756 5.66951L7.49178 9.05331L5.95237 7.52842C5.77809 7.33963 5.47311 7.33963 5.29884 7.52842C5.11005 7.7027 5.11005 8.00767 5.29884 8.18195L7.15775 10.0409C7.33203 10.2297 7.63701 10.2297 7.81128 10.0409L11.5291 6.32303Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.2fc6a84b8bbea9c1129af73b88f6f1f6.svg";
export { ForwardRef as ReactComponent };